import { ErrorMessage } from 'components/Zui'

const FieldError = ({ children }) => <ErrorMessage>{children}</ErrorMessage>

export default FieldError
